(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  function forceAltoCollectionGrid() {
    try {
      sessionStorage.removeItem('product-grid-view-desktop');
      sessionStorage.removeItem('product-grid-view-mobile');
    } catch (error) {}

    document.querySelectorAll('.product-grid').forEach((grid) => {
      grid.setAttribute('product-grid-view', 'default');
    });
  }

  forceAltoCollectionGrid();

  document.addEventListener('DOMContentLoaded', () => {
    forceAltoCollectionGrid();

    const url = new URL(window.location.href);
    if (url.hash) {
      const card = document.getElementById(url.hash.slice(1));
      if (card) {
        card.scrollIntoView({ behavior: 'instant' });
      }
    }

    new MutationObserver(forceAltoCollectionGrid).observe(document.body, {
      childList: true,
      subtree: true
    });
  });

  } catch(e) { console.error(e); }
})();
})();
